module.exports = __webpack_public_path__ + "img/lens-174-plus-01.d423a9cb.png";